export default {
    /**
     * Set timeline data
     *
     * @param state
     * @param data
     * @constructor
     */
    SET_TIMELINE_DATA: function (state, data) {
        if (state.firstPageUrl !== data.firstPageUrl) {
            state.items = [];
        }

        if (data.items !== null && data.items.length > 0) {
            data.items.forEach(element => {
                state.items.push(element);
            });
        }

        state.currentPage = data.currentPage;
        state.totalsPages = data.totalsPages;
        state.nextPageUrl = data.nextPageUrl;
        state.firstPageUrl = data.firstPageUrl;
    },

    /**
     * Enabling/disabling timeline loader
     *
     * @param state
     * @param loaderEnabled
     * @constructor
     */
    SET_LOADER_ENABLED: function (state, loaderEnabled = false) {
        state.loaderEnabled = loaderEnabled;
    },

    /**
     * Resetting time line items array
     *
     * @param state
     * @constructor
     */
    RESET_TIMELINE_ITEMS: function (state) {
        state.items = [];
    },

    /**
     * Set only mine
     *
     * @param state
     * @param onlyMine
     * @constructor
     */
    SET_ONLY_MINE: function (state, onlyMine = true) {
        state.onlyMine = onlyMine;
    },

    /**
     * Set next page url
     *
     * @param state
     * @param url
     * @constructor
     */
    SET_NEXT_PAGE_URL: function (state, url) {
        state.nextPageUrl = url;
    },

    /**
     * Set first page url
     *
     * @param state
     * @param url
     * @constructor
     */
    SET_FIRST_PAGE_URL: function (state, url) {
        state.firstPageUrl = url;
    },

    /**
     * Sets is maximized flag.
     *
     * @param state State object
     * @param isMaximized Is timeline maximized
     */
    SET_IS_MAXIMIZED (state, isMaximized) {
        state.isMaximized = isMaximized;
    },
};
